import React from "react";

const ImagenContainerHome = () => {
  return (
    <div className="py-2 my-4">
      <img
        src="assets/imagenes/ilustracion_inicial web_mejores_conductores.png"
        class="img1 img-fluid"
      ></img>
      <img
        src="assets/imagenes/ilustracion inicial web mejores conductores_movil-2.jpg"
        class="img2 img-fluid"
      ></img>
    </div>
  );
};

export default ImagenContainerHome;
